module.exports = __webpack_public_path__ + "static/assets/98cd4769145ea580a7d6fef9fdb62aab.png";